import { lazy } from 'react';
import { ROUTE_ACCOUNT } from 'src/config/account-routes';
import {
    ROUTE_ADMIN,
    ROUTE_AUTO_LOGIN,
    ROUTE_CONTACT,
    ROUTE_COOKIES,
    ROUTE_HOME,
    ROUTE_IMPRINT,
    ROUTE_PRIVACYPOLICY,
    ROUTE_REGISTER,
    ROUTE_STORE,
} from 'src/config/routes';
import { RouteDescriptor } from './SiteDefinition';

const AdminPanelHomeRoutes = lazy(() => import('src/adminPanel/components/pages/AdminPanelHomeRoutes'));
const StoreRoutes = lazy(() => import('src/pages/store/StoreRoutes'));
const CoffeehouseAccountRoutes = lazy(() => import('src/pages/account/CoffeehouseAccountRoutes'));
const Contact = lazy(() => import('src/pages/Contact'));
const Imprint = lazy(() => import('src/pages/Imprint'));
const PrivacyPolicy = lazy(() => import('src/pages/PrivacyPolicy'));
const Cookies = lazy(() => import('src/pages/Cookies'));
const AutoLogin = lazy(() => import('src/pages/AutoLogin'));
const CoffeehouseHome = lazy(() => import('src/pages/coffeehouse/CoffeehouseHome'));
// TEMPORARY (2026-07-29): self-registration, to bootstrap the first admin accounts.
// Remove this and registerEnabled in coffeehouseSite.tsx once they exist.
const RegisterRoutes = lazy(() => import('src/pages/register/RegisterRoutes'));

export const coffeehouseSiteRoutes: RouteDescriptor[] = [
    {
        key: 'admin-panel',
        route: ROUTE_ADMIN,
        component: AdminPanelHomeRoutes,
        condition: context => context.isLoggedIn && context.hasPrivilege('ADMIN'),
    },
    {
        key: 'store',
        route: ROUTE_STORE,
        component: StoreRoutes,
        condition: context => context.isLoggedIn,
    },
    {
        key: 'account',
        route: ROUTE_ACCOUNT,
        component: CoffeehouseAccountRoutes,
        condition: context => context.isLoggedIn,
    },
    {
        key: 'contact',
        route: ROUTE_CONTACT,
        component: Contact,
    },
    {
        key: 'imprint',
        route: ROUTE_IMPRINT,
        component: Imprint,
    },
    {
        key: 'privacy',
        route: ROUTE_PRIVACYPOLICY,
        component: PrivacyPolicy,
    },
    {
        key: 'cookies',
        route: ROUTE_COOKIES,
        component: Cookies,
    },
    {
        key: 'auto-login',
        route: ROUTE_AUTO_LOGIN,
        component: AutoLogin,
    },
    // TEMPORARY (2026-07-29) — see the RegisterRoutes import above.
    {
        key: 'register',
        route: ROUTE_REGISTER,
        component: RegisterRoutes,
    },
    {
        key: 'home',
        route: ROUTE_HOME,
        component: CoffeehouseHome,
    },
];
